import z from 'zod'
import { UTCMillisecondsSchema } from './time'
import { UserIdSchema } from './ids'

/** Switch closer and setter on calendarEvent */
export const CURRENT_VERSION: Version = 2
export type Version = number

export const AuditLogSchema = z.object({
  userId: UserIdSchema,
  timestamp: UTCMillisecondsSchema,
  updateProcess: z.string().optional(),
})

export type AuditLog = z.infer<typeof AuditLogSchema>

export const AuditHistorySchema = z.object({
  modifiedBy: z.array(AuditLogSchema).optional(),
})

export type AuditHistory = z.infer<typeof AuditHistorySchema>

export const AuditPropsSchema = z.object({
  ...AuditHistorySchema.shape,
  createdAt: UTCMillisecondsSchema.optional().meta({ id: 'auditPropsCreatedAt', deprecated: true }),
  createdBy: UserIdSchema.optional().meta({ id: 'auditPropsCreatedBy', deprecated: true }),
  updatedAt: UTCMillisecondsSchema.optional().meta({ id: 'auditPropsUpdatedAt' }),
  updatedBy: UserIdSchema.optional().meta({ id: 'auditPropsUpdatedBy', deprecated: true }),
  lastUpdateProcess: z.string().optional().meta({ id: 'auditPropsLastUpdateProcess' }),
  version: z.number().int().positive().optional().meta({ id: 'auditPropsVersion' }),
})

export type AuditProps = z.infer<typeof AuditPropsSchema>

// Consider merging the concepts of BooleanFilter and ArchivedFilter
export const BooleanFilterSchema = z.enum(['true', 'false', 'undefined', 'defined']).meta({
  id: 'booleanFilter',
  description: 'Boolean filter values',
  example: 'true',
})
export type BooleanFilter = z.infer<typeof BooleanFilterSchema>

export type WebHookResponseError = {
  errorCode: WebHookErrorCode
  errorMessage: string
}

export type WebHookErrorCode = 'InvalidUser' | 'UnknownError'

// Describes each presigned upload URL that read endpoints gate on `includeUploadUrls` (see IncludeUploadUrlsSchema).
export const UPLOAD_URL_DESCRIPTION =
  'present when `includeUploadUrls` is true or omitted (for now) and the caller can edit this entity; presigned PUT URL, expires in about 1h'

export const MediaSchema = z.object({
  blurhash: z.string().optional(),
  download: z.string().optional(),
  upload: z.string().optional(),
})
export type Media = z.infer<typeof MediaSchema>

export const EmptyStringSchema = z.literal('')
